import {Typography, useTheme, css} from '@mui/material';
import {DlMuiPopper, GetStylesFunction, mixins, useMuiAnchor} from '@wallaby-ui/core';
import {ICellRendererParams} from 'ag-grid-community';
import * as React from 'react';
import {useIntl} from 'react-intl';
import {useStore} from 'react-redux';
import {useParams} from 'react-router-dom';
import {EntityLink} from 'src/js/containers/file/components/EntityLink';
import {getHospitalizationDocumentLink} from 'src/js/containers/hospitalizations/hospitalizations_helpers';
import {baseDocumentsListLinkFormatterParams} from 'src/js/lib/raw_rendering/base_documents_list_link_formatter_params';

type OwnProps = ICellRendererParams;

type Props = OwnProps;

export const DocumentsListLinkFormatter: React.FC<Props> = (props) => {
  const intl = useIntl();
  const routeParams = useParams();
  const store = useStore();

  const {documentId, hospitalizationId, formattedValue, searchParams} = baseDocumentsListLinkFormatterParams(props, {
    intl,
    routeParams,
    store,
  });

  const hasTooltip = !!formattedValue;

  const {mouseEventEnter, mouseEventLeave, open, anchorEl} = useMuiAnchor(hasTooltip);

  const theme = useTheme();
  const styles = getStyles({theme});
  const route = hospitalizationId && documentId ? getHospitalizationDocumentLink(hospitalizationId, documentId, '') : '';

  return (
    <Typography css={styles.wrapper} variant={'textButton'}>
      <div css={styles.dlLinkFormatter}>
        <EntityLink route={route} searchParams={searchParams} suppressPadding>
          <span css={styles.span} onMouseEnter={mouseEventEnter} onMouseLeave={mouseEventLeave}>
            {formattedValue}
          </span>
          <DlMuiPopper hasTooltip={hasTooltip} anchorEl={anchorEl} open={open}>
            <Typography variant={'popper'}>{formattedValue}</Typography>
          </DlMuiPopper>
        </EntityLink>
      </div>
    </Typography>
  );
};

DocumentsListLinkFormatter.displayName = 'DocumentsListLinkFormatter';

const getStyles: GetStylesFunction = (options) => ({
  span: css`
    ${mixins.dlTextOverflowEllipses};
    text-decoration: underline;
    padding: ${options?.theme?.spacing(1, 0)};
  `,
  wrapper: css`
    line-height: unset;
    display: flex;
    flex-direction: row;
    align-items: center;
  `,
  dlLinkFormatter: css`
    ${mixins.dlTextOverflowEllipses};
    min-width: 0;
  `,
});
